import commeDesGarcons from "./comme-des-garcons";
import sacai from "./sacai";
import maisonMargiela from "./maison-margiela";
import commeDesGarconsHommePlus from "./comme-des-garcons-homme-plus";
import junyaWatanabe from "./junya-watanabe";
import noirKeiNinomiya from "./noir-kei-ninomiya";
import rafSimons from "./raf-simons";
import rickOwens from "./rick-owens";
import isseyMiyake from "./issey-miyake";
import yohjiYamamoto from "./yohji-yamamoto";
import taoCommeDesGarcons from "./tao-comme-des-garcons";
import pleatsPleaseIsseyMiyake from "./pleats-please-issey-miyake"

export const brandBuybackArticles = [
  commeDesGarcons,
  sacai,
  maisonMargiela,
  commeDesGarconsHommePlus,
  junyaWatanabe,
  noirKeiNinomiya,
  rafSimons,
  rickOwens,
  isseyMiyake,
  yohjiYamamoto,
  taoCommeDesGarcons,
  pleatsPleaseIsseyMiyake,
];
